// extracted by mini-css-extract-plugin
export default {"container":"SK-z","dimension":"TK-z","dimensionLabels":"UK-z"};